export const GET_ENTITY_FEATURE_LIST_REQUEST =
  'GET_ENTITY_FEATURE_LIST_REQUEST';
export const GET_ENTITY_FEATURE_LIST_SUCCESS =
  'GET_ENTITY_FEATURE_LIST_SUCCESS';
export const GET_ENTITY_FEATURE_LIST_ERROR = 'GET_ENTITY_FEATURE_LIST_ERROR';
export const ADD_ENTITY_FEATURE_REQUEST = 'ADD_ENTITY_FEATURE_REQUEST';
export const ADD_ENTITY_FEATURE_SUCCESS = 'ADD_ENTITY_FEATURE_SUCCESS';
export const ADD_ENTITY_FEATURE_ERROR = 'ADD_ENTITY_FEATURE_ERROR';
export const UPDATE_ENTITY_FEATURE_REQUEST = 'UPDATE_ENTITY_FEATURE_REQUEST';
export const UPDATE_ENTITY_FEATURE_SUCCESS = 'UPDATE_ENTITY_FEATURE_SUCCESS';
export const UPDATE_ENTITY_FEATURE_ERROR = 'UPDATE_ENTITY_FEATURE_ERROR';
export const GET_ENTITY_FEATURE_REQUEST = 'GET_ENTITY_FEATURE_REQUEST';
export const GET_ENTITY_FEATURE_SUCCESS = 'GET_ENTITY_FEATURE_SUCCESS';
export const GET_ENTITY_FEATURE_ERROR = 'GET_ENTITY_FEATURE_ERROR';
export const DELETE_ENTITY_FEATURE_REQUEST = 'DELETE_ENTITY_FEATURE_REQUEST';
export const DELETE_ENTITY_FEATURE_SUCCESS = 'DELETE_ENTITY_FEATURE_SUCCESS';
export const DELETE_ENTITY_FEATURE_ERROR = 'DELETE_ENTITY_FEATURE_ERROR';
export const UPDATE_ENTITY_FEATURE_LIST_PAGINATION_OPTIONS =
  'UPDATE_ENTITY_FEATURE_LIST_PAGINATION_OPTIONS';
